(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cosmosphere-discovery"] && !Shopify.designMode) return;
  try {
    
function initCsDiscovery(root){root.querySelectorAll('[data-cs-discovery]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const tabs=[...section.querySelectorAll('[data-scent-tab]')];const panels=[...section.querySelectorAll('[data-scent]')];if(!tabs.length)return;section.querySelector('[data-cs-tabs]').setAttribute('role','tablist');tabs.forEach(tab=>{tab.setAttribute('role','tab');tab.setAttribute('aria-controls','scent-'+tab.dataset.scentTab)});panels.forEach(panel=>{panel.setAttribute('role','tabpanel');panel.tabIndex=0});let active='';let transition;const show=(key,animate=true)=>{if(!tabs.some(t=>t.dataset.scentTab===key)||key===active)return;const change=()=>{active=key;tabs.forEach(t=>{const selected=t.dataset.scentTab===key;t.setAttribute('aria-selected',String(selected));t.tabIndex=selected?0:-1});panels.forEach(p=>{p.hidden=p.dataset.scent!==key;p.classList.toggle('is-current',!p.hidden)})};if(animate&&document.startViewTransition&&!matchMedia('(prefers-reduced-motion: reduce)').matches){transition?.skipTransition();transition=document.startViewTransition(change)}else change()};tabs.forEach((tab,i)=>{tab.addEventListener('click',e=>{e.preventDefault();show(tab.dataset.scentTab)});tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();tabs[next].focus();show(tabs[next].dataset.scentTab)}})});show(location.hash.replace('#scent-',''),false);if(!active)show(tabs[0].dataset.scentTab,false);document.addEventListener('cs:select-scent',e=>{show(e.detail.key,false);section.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});tabs.find(t=>t.dataset.scentTab===e.detail.key)?.focus({preventScroll:true})});window.addEventListener('hashchange',()=>show(location.hash.replace('#scent-','')));document.addEventListener('shopify:block:select',e=>{const p=e.target.closest('[data-scent]');if(p&&section.contains(p))show(p.dataset.scent,false)})})}initCsDiscovery(document);document.addEventListener('shopify:section:load',e=>initCsDiscovery(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cosmosphere-film"] && !Shopify.designMode) return;
  try {
    
function initCosmosphereFilm(root){root.querySelectorAll('[data-cs-film]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const video=section.querySelector('video');const button=section.querySelector('button');if(!video||!button)return;let userPaused=false;const motion=window.matchMedia('(prefers-reduced-motion: reduce)');const update=()=>{button.setAttribute('aria-label',video.paused?button.dataset.playLabel:button.dataset.pauseLabel);button.querySelector('span').textContent=video.paused?'▶':'Ⅱ';};const play=()=>{video.muted=true;video.play().catch(update);};video.addEventListener('play',update);video.addEventListener('pause',update);video.addEventListener('error',()=>{button.hidden=true;});button.addEventListener('click',()=>{userPaused=!video.paused;if(video.paused)play();else video.pause();});if(motion.matches){video.autoplay=false;video.pause();}else play();motion.addEventListener('change',()=>{if(motion.matches)video.pause();else if(!userPaused)play();});document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else if(!userPaused&&!motion.matches)play();});update();});}initCosmosphereFilm(document);document.addEventListener('shopify:section:load',event=>initCosmosphereFilm(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cosmosphere-finder"] && !Shopify.designMode) return;
  try {
    
function initCsFinder(root){root.querySelectorAll('[data-cs-finder]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const form=section.querySelector('form');const fields=[...form.querySelectorAll('fieldset')];const next=form.querySelector('[data-quiz-next]');const back=form.querySelector('[data-quiz-back]');const progress=form.querySelector('[data-quiz-step]');const result=section.querySelector('[data-quiz-result]');const scents=[...section.querySelectorAll('[data-quiz-scent]')].map(el=>el.dataset);if(scents.length!==4)return;let step=0;const weights=[[[4,1,0,2],[0,4,2,1],[1,1,4,2],[1,1,2,4]],[[8,1,0,2],[1,8,2,1],[0,1,8,2],[2,1,2,8]],[[3,0,1,1],[1,3,2,3],[0,2,3,3],[1,1,1,1]]];const update=(focus=false)=>{fields.forEach((f,i)=>f.hidden=i!==step);progress.textContent=String(step+1).padStart(2,'0');next.textContent=step===2?next.dataset.result:next.dataset.next;next.disabled=!fields[step].querySelector('input:checked');back.disabled=step===0;if(focus)fields[step].querySelector('legend').focus()};form.hidden=false;update();form.addEventListener('change',()=>update());back.addEventListener('click',()=>{if(step>0){step--;update(true)}});const explore=(e,key)=>{e.preventDefault();document.dispatchEvent(new CustomEvent('cs:select-scent',{detail:{key}}))};form.addEventListener('submit',e=>{e.preventDefault();if(next.disabled)return;if(step<2){step++;update(true);return}const selected=fields.map(f=>Number(f.querySelector('input:checked').value)-1);const ranked=scents.map((s,i)=>({...s,score:selected.reduce((v,a,q)=>v+weights[q][a][i],0),tie:weights[1][selected[1]][i]})).sort((a,b)=>b.score-a.score||b.tie-a.tie);const first=ranked[0],second=ranked[1];result.querySelector('[data-result-name]').textContent=first.name;result.querySelector('[data-result-notes]').textContent=first.notes;result.querySelector('[data-result-reason]').textContent=first.reason;const link=result.querySelector('[data-result-link]');link.href='#scent-'+first.quizScent;link.onclick=e=>explore(e,first.quizScent);const alt=result.querySelector('[data-alternative-link]');alt.textContent=second.name+' ↗';alt.href='#scent-'+second.quizScent;alt.onclick=e=>explore(e,second.quizScent);form.hidden=true;result.hidden=false;result.querySelector('h3').focus()});section.querySelector('[data-quiz-reset]').addEventListener('click',()=>{form.reset();step=0;result.hidden=true;form.hidden=false;update(true)})})}initCsFinder(document);document.addEventListener('shopify:section:load',e=>initCsFinder(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cosmosphere-journey"] && !Shopify.designMode) return;
  try {
    
function initCsJourney(root){root.querySelectorAll('[data-cs-journey]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const button=section.querySelector('button');button?.addEventListener('click',()=>{const frame=section.querySelector('.cs-journey__frame');const alternate=frame.classList.toggle('is-alternate');button.setAttribute('aria-pressed',String(alternate))})})}initCsJourney(document);document.addEventListener('shopify:section:load',e=>initCsJourney(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-shop-preview"]) return;
  try {
    
const legacyCatalog = document.querySelector('[data-cs-catalog-redirect]');
if (legacyCatalog) {
  const hash = window.location.hash.slice(1);
  const handle = new URLSearchParams(hash).get('product');
  let path = 'collections/koleksiyon';
  if (handle && /^(?:cs0[1-4]|d1)-[a-z0-9-]+$/.test(handle)) path = 'products/' + handle;
  else if (hash === 'sets') path = 'collections/rituel-setleri';
  else if (hash === 'cart' || hash === 'checkout') path = 'cart';
  window.location.replace(legacyCatalog.dataset.root + path);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);


function initCsHeader(){const section=document.querySelector('.section-header');if(!section||section.dataset.csReady)return;section.dataset.csReady='true';const update=()=>section.classList.toggle('cs-header-solid',scrollY>48);let pending=false;window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(()=>{update();pending=false})}},{passive:true});update();const menu=section.querySelector('.cs-mobile-nav');if(menu){menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>menu.open=false));menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus()}});document.addEventListener('click',e=>{if(menu.open&&!menu.contains(e.target))menu.open=false})}}initCsHeader();document.addEventListener('shopify:section:load',initCsHeader);


  } catch(e) { console.error(e); }
})();
})();
